"use client";

// TEMPORARY: translation-key usage capture for the CMS migration.
import recordPhraseUsageClient from "@workspace/cms-phrases/src/client/recorder";
import { BADGE_TRANSLATION_KEYS } from "@workspace/frontend-ui";
import { useEffect, useMemo } from "react";
import allTranslations from "../../../translations";
import { SEARCH_MODAL_TRANSLATION_KEYS } from "../translationKeys";

type Result = {
  t: (key: string) => string;
  badgeLabels: Record<string, string>;
};

const useTranslations = (locale: string): Result => {
  const dictionary = allTranslations[locale] ?? allTranslations.en;

  const { t, badgeLabels } = useMemo(() => {
    const translate = (key: string): string => dictionary[key] || key;
    const labels = Object.fromEntries(
      BADGE_TRANSLATION_KEYS.map((key) => [key, translate(key)]),
    );
    return { t: translate, badgeLabels: labels };
  }, [dictionary]);

  useEffect(() => {
    for (const key of SEARCH_MODAL_TRANSLATION_KEYS) {
      recordPhraseUsageClient(key, t(key));
    }
    for (const key of BADGE_TRANSLATION_KEYS) {
      recordPhraseUsageClient(key, badgeLabels[key]);
    }
  }, [t, badgeLabels]);

  return { t, badgeLabels };
};

export default useTranslations;
